import React from 'react';

import classnames from 'clsx';
import PropTypes from 'prop-types';

import { convertUnitPositionToAdornmentPosition, UnitAdornment } from 'ui-components/components/number-input/unit-adornment';

import { UnitPosition, UnitPositionPropType } from '../../../../enums/units/unit-position';
import { FormattedMessagePropType } from '../../../../prop-types/intl';
import { NumberInput } from '../../number-input';

import style from './style.module.less';

export const WeightNumberInput = ({
  value = null,
  weightUnitLabel,
  placeholder = null,
  min = null,
  className = null,
  onArrowButtonPress = null,
  onChange,
  onBlur,
  onFocus = null,
  onKeyDown,
  disabled = false,
  shrinkable = false,
  testId = null,
  unitPosition = UnitPosition.OutsideEnd,
  containerClassName,
  testDataInputType,
  labelId,
  parentLabelId,
}) => {
  const adornmentPosition = convertUnitPositionToAdornmentPosition(unitPosition);
  const inputLabel = parentLabelId ? `${parentLabelId} ${labelId}` : labelId;

  return (
    <div className={classnames(style.unit, containerClassName)} data-input-type={testDataInputType}>
      <NumberInput
        adornment={<UnitAdornment id={labelId} unitLabel={weightUnitLabel} unitPosition={unitPosition} />}
        adornmentPosition={adornmentPosition}
        className={className}
        disabled={disabled}
        labelId={inputLabel}
        min={min}
        onArrowButtonPress={onArrowButtonPress}
        onBlur={onBlur}
        onChange={onChange}
        onFocus={onFocus}
        onKeyDown={onKeyDown}
        placeholder={placeholder}
        shrinkable={shrinkable}
        testId={testId}
        value={value}
      />
      {unitPosition === UnitPosition.OutsideEnd && <label id={labelId}>{weightUnitLabel}</label>}
    </div>
  );
};

WeightNumberInput.propTypes = {
  value: PropTypes.number,
  min: PropTypes.number,
  placeholder: PropTypes.string,
  weightUnitLabel: PropTypes.oneOfType([FormattedMessagePropType, PropTypes.node]).isRequired,
  onArrowButtonPress: PropTypes.func,
  onBlur: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  shrinkable: PropTypes.bool,
  testId: PropTypes.string,
  onFocus: PropTypes.func,
  unitPosition: UnitPositionPropType,
  containerClassName: PropTypes.string,
  testDataInputType: PropTypes.string,
  labelId: PropTypes.string,
  parentLabelId: PropTypes.string,
};
